import { render } from "./CatalogTabs.vue?vue&type=template&id=44eb76fd&scoped=true"
import script from "./CatalogTabs.vue?vue&type=script&lang=js"
export * from "./CatalogTabs.vue?vue&type=script&lang=js"

import "./CatalogTabs.vue?vue&type=style&index=0&id=44eb76fd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44eb76fd"]])

export default __exports__